module.exports = __webpack_public_path__ + "img/osago-humans.9e72e96.svg";